import React from "react";
import "./PcaWhyProblems.css";

const problems = [
  "Listings and dealer inventory show asking prices, not what the market actually pays.",
  "Comps, color splits, and spec differences take hours to piece together, and you still don't get a clean number.",
  "Rare specs hide real value. Miss it as a seller and you set your reserve too low. Miss it as a buyer and you overpay for a car that isn't special."
];

function PcaWhyProblems() {
  return (
    <div className="why-problems">
      {problems.map((problem, index) => (
        <div className="why-problems__card" key={index}>
          <span className="why-problems__icon" aria-hidden="true">✕</span>
          <p className="why-problems__text">{problem}</p>
        </div>
      ))}
    </div>
  );
}

export default PcaWhyProblems;
